<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 181 150"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>fast-food-diners</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-605.000000, -233.000000)">
        <g
          id="fast-food-diners"
          transform="translate(606.000000, 233.000000)">
          <g id="Background">
            <g id="New_Symbol_80-72">
              <path
                id="Path"
                d="M172.125026,82.1454545 C172.121871,48.7321581 151.801398,18.6780832 120.794488,6.2273845 C89.7875772,-6.22331418 54.3252861,1.43141898 31.2149978,25.5636166 C8.10470947,49.6958142 1.99059909,85.4559412 15.7704545,115.895455 L164.843182,115.895455 C169.651374,105.294092 172.134284,93.7862243 172.125026,82.1454545 Z"
                class="fill-extra-light"
                fill-rule="nonzero" />
              <line
                id="Path"
                x1="9.51136364"
                y1="115.915909"
                x2="169.056818"
                y2="115.915909"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="0.306818182"
                y1="115.915909"
                x2="5.42045455"
                y2="115.915909"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="173.147727"
                y1="115.915909"
                x2="178.261364"
                y2="115.915909"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </g>
          <g
            id="Scene"
            transform="translate(27.590909, 11.227273)">
            <path
              id="Path"
              d="M65.7840909,92.3954545 L65.7840909,104.668182 L104.647727,104.668182 L104.647727,92.3954545 L116.920455,92.3954545 L116.920455,89.3272727 C116.920455,71.8173358 102.725846,57.6227273 85.2159091,57.6227273 C67.7059721,57.6227273 53.5113636,71.8173358 53.5113636,89.3272727 L53.5113636,92.3954545 L65.7840909,92.3954545 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M65.7840909,92.3954545 L65.7840909,104.668182 L104.647727,104.668182 L104.647727,92.3954545 L114.875,92.3954545 C116.004673,92.3954545 116.920455,91.4796734 116.920455,90.35 L116.920455,89.3272727 C116.920455,71.8173358 102.725846,57.6227273 85.2159091,57.6227273 C67.7059721,57.6227273 53.5113636,71.8173358 53.5113636,89.3272727 L53.5113636,90.35 C53.5113636,91.4796734 54.4271448,92.3954545 55.5568182,92.3954545 L65.7840909,92.3954545 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M55.2090909,92.3954545 C54.3418687,94.8483304 52.0221218,96.4877275 49.4204545,96.4863636 C46.25,96.4863636 43.2840909,94.3181818 43.2840909,89.3272727 C43.2840909,86.5030893 40.9946379,84.2136364 38.1704545,84.2136364 C35.3462712,84.2136364 33.0568182,86.5030893 33.0568182,89.3272727 C33.0568182,100.331818 40.9931818,106.713636 49.4204545,106.713636 C57.6690918,106.716468 64.6302844,100.579396 65.6613636,92.3954545 L55.2090909,92.3954545 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M91.3522727,88.3045455 C91.3522727,87.1748721 90.4364915,86.2590909 89.3068182,86.2590909 L81.125,86.2590909 C79.9953266,86.2590909 79.0795455,87.1748721 79.0795455,88.3045455 L79.0795455,106.713636 L91.3522727,106.713636 L91.3522727,88.3045455 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M89.3068182,84.2136364 C89.3068182,83.083963 88.391037,82.1681818 87.2613636,82.1681818 L83.1704545,82.1681818 C82.0407812,82.1681818 81.125,83.083963 81.125,84.2136364 L81.125,86.2590909 L89.3068182,86.2590909 L89.3068182,84.2136364 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M86.3409091,76.5431818 C86.290488,76.244707 86.0299468,76.0275893 85.7272727,76.0317575 L84.725,76.0317575 C84.4223259,76.0275893 84.1617847,76.244707 84.1113636,76.5431818 L83.1704545,82.1681818 L87.2613636,82.1681818 L86.3409091,76.5431818 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M91.3522727,88.3045455 C91.3522727,87.1748721 90.4364915,86.2590909 89.3068182,86.2590909 L81.125,86.2590909 C79.9953266,86.2590909 79.0795455,87.1748721 79.0795455,88.3045455 L79.0795455,106.713636 L91.3522727,106.713636 L91.3522727,88.3045455 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M104.647727,92.3954545 C104.647727,94.6548012 102.816165,96.4863636 100.556818,96.4863636 L79.0795455,96.4863636 C76.2553621,96.4863636 73.9659091,98.7758166 73.9659091,101.6 C73.9659091,104.424183 76.2553621,106.713636 79.0795455,106.713636 L100.556818,106.713636 C108.464532,106.713636 114.875,100.303168 114.875,92.3954545 L104.647727,92.3954545 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="65.7840909"
              y1="92.3954545"
              x2="65.7840909"
              y2="86.2590909"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="104.647727"
              y1="92.3954545"
              x2="104.647727"
              y2="86.2590909"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M78.0568182,58.6454545 C78.0568182,62.5993113 81.2620524,65.8045455 85.2159091,65.8045455 C89.1697658,65.8045455 92.375,62.5993113 92.375,58.6454545 L92.375,51.4863636 L78.0568182,51.4863636 L78.0568182,58.6454545 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M78.0568182,58.6454545 L78.0568182,51.4863636 L92.375,51.4863636 L92.375,58.6454545 C92.375,62.5993113 89.1697658,65.8045455 85.2159091,65.8045455 C81.2620524,65.8045455 78.0568182,62.5993113 78.0568182,58.6454545 L78.0568182,58.6454545 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <ellipse
              id="Oval"
              class="fill-extra-light"
              fill-rule="nonzero"
              cx="98.5113636"
              cy="126.145455"
              rx="14.3181818"
              ry="3.06818182" />
            <path
              id="Path"
              d="M10.5568182,84.2136364 L2.375,84.2136364 C1.24532665,84.2136364 0.329545455,85.1294176 0.329545455,86.2590909 L0.329545455,104.668182 L12.6022727,104.668182 L12.6022727,86.2590909 C12.6022727,85.1294176 11.6864915,84.2136364 10.5568182,84.2136364 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M8.51136364,80.1227273 L4.42045455,80.1227273 C3.29078119,80.1227273 2.375,81.0385085 2.375,82.1681818 L2.375,84.2136364 L10.5568182,84.2136364 L10.5568182,82.1681818 C10.5568182,81.0385085 9.64103699,80.1227273 8.51136364,80.1227273 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M7.59090909,74.4977273 C7.54048803,74.1992525 7.27994679,73.9821348 6.97727273,73.9863029 L5.975,73.9863029 C5.67232594,73.9821348 5.4117847,74.1992525 5.36136364,74.4977273 L4.42045455,80.1227273 L8.51136364,80.1227273 L7.59090909,74.4977273 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M10.5568182,84.2136364 L2.375,84.2136364 C1.24532665,84.2136364 0.329545455,85.1294176 0.329545455,86.2590909 L0.329545455,104.668182 L12.6022727,104.668182 L12.6022727,86.2590909 C12.6022727,85.1294176 11.6864915,84.2136364 10.5568182,84.2136364 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M71.6340909,134.306818 L58.7477273,112.870455 L17.4090909,112.870455 L4.52272727,134.306818 C4.1371764,134.940106 4.12450333,135.732448 4.48960399,136.377742 C4.85470465,137.023036 5.54041121,137.420242 6.28181818,137.415944 L69.875,137.415944 C70.616407,137.420242 71.3021135,137.023036 71.6672142,136.377742 C72.0323148,135.732448 72.0196418,134.940106 71.6340909,134.306818 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <ellipse
              id="Oval"
              class="fill-extra-light"
              fill-rule="nonzero"
              cx="38.1704545"
              cy="128.190909"
              rx="26.5909091"
              ry="3.06818182" />
            <path
              id="Path"
              d="M61.6318182,121.031818 C65.0208382,121.031818 67.7681818,118.284475 67.7681818,114.895455 C67.7681818,111.506434 65.0208382,108.759091 61.6318182,108.759091 L14.5863636,108.759091 C11.1973436,108.759091 8.45,111.506434 8.45,114.895455 C8.45,118.284475 11.1973436,121.031818 14.5863636,121.031818 L61.6318182,121.031818 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="24.8136364"
              y1="108.759091"
              x2="28.9045455"
              y2="112.85"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="32.9954545"
              y1="108.759091"
              x2="37.0863636"
              y2="112.85"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="41.1772727"
              y1="108.759091"
              x2="45.2681818"
              y2="112.85"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="49.3590909"
              y1="108.759091"
              x2="53.45"
              y2="112.85"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="51.4045455"
              y1="108.759091"
              x2="47.3136364"
              y2="112.85"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="43.2227273"
              y1="108.759091"
              x2="39.1318182"
              y2="112.85"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="35.0409091"
              y1="108.759091"
              x2="30.95"
              y2="112.85"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="26.8590909"
              y1="108.759091"
              x2="22.7681818"
              y2="112.85"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M58.5636364,112.85 C61.3878197,112.85 63.6772727,115.139453 63.6772727,117.963636 C63.6772727,123.056818 52.2227273,127.168182 38.1090909,127.168182 C23.9954545,127.168182 12.5409091,123.077273 12.5409091,117.963636 C12.5409091,115.139453 14.8303621,112.85 17.6545455,112.85 L58.5636364,112.85 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M58.5636364,112.85 C61.3878197,112.85 63.6772727,115.139453 63.6772727,117.963636 C63.6772727,123.056818 52.2227273,127.168182 38.1090909,127.168182 C23.9954545,127.168182 12.5409091,123.077273 12.5409091,117.963636 C12.5409091,115.139453 14.8303621,112.85 17.6545455,112.85 L58.5636364,112.85 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M108.738648,108.759091 C108.74125,107.819611 108.310434,106.93143 107.571008,106.35188 C106.831582,105.77233 105.866194,105.566189 104.954545,105.793182 C104.024319,104.639473 102.392178,104.335617 101.109091,105.077273 C100.552754,104.183398 99.5744549,103.639976 98.5215909,103.639976 C97.4687269,103.639976 96.4904281,104.183398 95.9340909,105.077273 C94.6510042,104.335617 93.0188627,104.639473 92.0886364,105.793182 C91.1769876,105.566189 90.2115999,105.77233 89.4721739,106.35188 C88.7327478,106.93143 88.3019317,107.819611 88.3045336,108.759091 L108.738648,108.759091 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M104.115909,125.122855 L92.9272727,125.122855 C90.8534373,125.138985 89.0955373,123.600823 88.8363636,121.543182 L87.2409091,108.759091 L109.740909,108.759091 L108.145455,121.543182 C107.889193,123.577619 106.16637,125.108046 104.115909,125.122855 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M104.115909,125.122855 L92.9272727,125.122855 C90.8534373,125.138985 89.0955373,123.600823 88.8363636,121.543182 L87.2409091,108.759091 L109.740909,108.759091 L108.145455,121.543182 C107.889193,123.577619 106.16637,125.108046 104.115909,125.122855 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M51.4659091,84.2136364 C53.7252558,84.2136364 55.5568182,82.382074 55.5568182,80.1227273 C55.5568182,77.8633806 53.7252558,76.0318182 51.4659091,76.0318182 L24.875,76.0318182 C22.6156533,76.0318182 20.7840909,77.8633806 20.7840909,80.1227273 C20.7840909,82.382074 22.6156533,84.2136364 24.875,84.2136364 L51.4659091,84.2136364 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="28.9659091"
              y1="76.0318182"
              x2="33.0568182"
              y2="80.1227273"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="37.1477273"
              y1="76.0318182"
              x2="41.2386364"
              y2="80.1227273"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="45.3295455"
              y1="76.0318182"
              x2="49.4204545"
              y2="80.1227273"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="47.375"
              y1="76.0318182"
              x2="43.2840909"
              y2="80.1227273"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="39.1931818"
              y1="76.0318182"
              x2="35.1022727"
              y2="80.1227273"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="31.0113636"
              y1="76.0318182"
              x2="26.9204545"
              y2="80.1227273"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M51.4659091,80.1227273 C52.5955824,80.1227273 53.5113636,81.0385085 53.5113636,82.1681818 C53.5113636,85.5636364 46.6386364,88.3045455 38.1704545,88.3045455 C29.7022727,88.3045455 22.8295455,85.5636364 22.8295455,82.1681818 C22.8295455,81.0385085 23.7453266,80.1227273 24.875,80.1227273 L51.4659091,80.1227273 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M51.4659091,80.1227273 C52.5955824,80.1227273 53.5113636,81.0385085 53.5113636,82.1681818 C53.5113636,85.5636364 46.6386364,88.3045455 38.1704545,88.3045455 C29.7022727,88.3045455 22.8295455,85.5636364 22.8295455,82.1681818 C22.8295455,81.0385085 23.7453266,80.1227273 24.875,80.1227273 L51.4659091,80.1227273 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M105.670455,30.0090909 L105.670455,24.8954545 C105.670455,13.598721 96.5126426,4.44090909 85.2159091,4.44090909 C73.9191756,4.44090909 64.7613636,13.598721 64.7613636,24.8954545 L64.7613636,30.0090909 C62.5020169,30.0090909 60.6704545,31.8406533 60.6704545,34.1 C60.6704545,36.3593467 62.5020169,38.1909091 64.7613636,38.1909091 L65.0068182,38.1909091 C66.5912281,48.1174077 75.1535314,55.4214295 85.2056818,55.4214295 C95.2578323,55.4214295 103.820136,48.1174077 105.404545,38.1909091 L105.65,38.1909091 C107.909347,38.1909091 109.740909,36.3593467 109.740909,34.1 C109.740909,31.8406533 107.909347,30.0090909 105.65,30.0090909 L105.670455,30.0090909 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M96.4659091,32.0545455 C95.9426359,30.8240616 94.7348531,30.0252237 93.3977273,30.0252237 C92.0606015,30.0252237 90.8528187,30.8240616 90.3295455,32.0545455"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M80.1227273,32.0545455 C79.599454,30.8240616 78.3916713,30.0252237 77.0545455,30.0252237 C75.7174196,30.0252237 74.5096369,30.8240616 73.9863636,32.0545455"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="73.4545455"
              cy="38.7022727"
              r="2.55681818" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="96.9772727"
              cy="38.7022727"
              r="2.55681818" />
            <path
              id="Path"
              d="M88.55,40.2363636 C87.1489747,40.2598149 85.8716038,41.043478 85.2159091,42.2818182 C84.5602144,41.043478 83.2828435,40.2598149 81.8818182,40.2363636 C76.8090909,40.2363636 74.1704545,49.8704545 74.1704545,49.8704545 C76.6694438,48.9709773 79.253069,48.3267843 81.8818182,47.9477273 C83.2828435,47.924276 84.5602144,47.1406129 85.2159091,45.9022727 C85.8716038,47.1406129 87.1489747,47.924276 88.55,47.9477273 C91.1787492,48.3267843 93.7623744,48.9709773 96.2613636,49.8704545 C96.2613636,49.8704545 93.6227273,40.2363636 88.55,40.2363636 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M87.3227273,4.54318182 C86.6272727,4.54318182 85.9318182,4.44090909 85.2772727,4.44090909 C84.6227273,4.44090909 83.8659091,4.44090909 83.2318182,4.54318182 C72.7797286,5.59365635 64.8227273,14.3907092 64.8227273,24.8954545 L64.8227273,30.0090909 C66.6646768,30.1478876 68.0899992,31.6801093 68.0954545,33.5272727 C68.8744024,30.8222321 69.0282788,27.9755173 68.5454545,25.2022727 C70.6931818,25.9181818 74.2522727,22.85 74.2522727,22.85 L74.2522727,17.9409091 C77.8267263,19.1836755 81.5333447,20.0073685 85.2977273,20.3954545 C89.0621098,20.0073685 92.7687282,19.1836755 96.3431818,17.9409091 L96.3431818,22.85 C96.3431818,22.85 99.8818182,25.9181818 102.05,25.2022727 C101.56053,27.9739724 101.707411,30.8206681 102.479545,33.5272727 C102.485001,31.6801093 103.910323,30.1478876 105.752273,30.0090909 L105.752273,24.8954545 C105.751354,14.3836228 97.782919,5.58385312 87.3227273,4.54318182 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M106.693182,7.50909091 C105.393913,8.1016236 103.901542,8.1016236 102.602273,7.50909091 C101.313636,6.85454545 95.4431818,0.35 85.2159091,0.35 C74.9886364,0.35 69.1181818,6.85454545 67.8295455,7.50909091 C66.5302765,8.1016236 65.0379053,8.1016236 63.7386364,7.50909091 C62.45,10.9454545 63.8818182,14.75 65.9681818,18.0022727 C67.5582383,20.4084852 69.4180277,22.6251346 71.5113636,24.6090909 C72.4563432,24.1165469 73.3475055,23.5270088 74.1704545,22.85 L74.1704545,17.9409091 C77.7449082,19.1836755 81.4515265,20.0073685 85.2159091,20.3954545 C88.9802917,20.0073685 92.68691,19.1836755 96.2613636,17.9409091 L96.2613636,22.85 C97.0843126,23.5270088 97.975475,24.1165469 98.9204545,24.6090909 C101.01379,22.6251346 102.87358,20.4084852 104.463636,18.0022727 C106.55,14.75 108.002273,10.9659091 106.693182,7.50909091 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M106.693182,7.50909091 C105.393913,8.1016236 103.901542,8.1016236 102.602273,7.50909091 C101.313636,6.85454545 95.4431818,0.35 85.2159091,0.35 C74.9886364,0.35 69.1181818,6.85454545 67.8295455,7.50909091 C66.5302765,8.1016236 65.0379053,8.1016236 63.7386364,7.50909091 C62.45,10.9454545 63.8818182,14.75 65.9681818,18.0022727 C67.5582383,20.4084852 69.4180277,22.6251346 71.5113636,24.6090909 C72.4563432,24.1165469 73.3475055,23.5270088 74.1704545,22.85 L74.1704545,17.9409091 C77.7449082,19.1836755 81.4515265,20.0073685 85.2159091,20.3954545 C88.9802917,20.0073685 92.68691,19.1836755 96.2613636,17.9409091 L96.2613636,22.85 C97.0843126,23.5270088 97.975475,24.1165469 98.9204545,24.6090909 C101.01379,22.6251346 102.87358,20.4084852 104.463636,18.0022727 C106.55,14.75 108.002273,10.9659091 106.693182,7.50909091 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
